import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Gateway } from '../BaseUrl';
import { Button } from './Button';
import { Form } from './Form';
import { Input } from './Input';
import { SupportEmail } from './Variables';
import { Login } from '../Ajax';

export default class LoginPage extends Component {
    displayName = LoginPage.name

    constructor(props) {
        super(props);

        this.state = {
            name: '',
            password: '',
            loading: false,
            errorMessage: "Oops.. Something whent wrong! If the error persists contact " + SupportEmail,
            hasError: false
        }
        
        this.username = React.createRef();
        this.password = React.createRef();
        this.login = this.login.bind(this);
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    updateState(object, func = () => { }) {
        if (this._isMounted) {
            this.setState(object, func);
        }
    }
    async login() {
        const { loading, name, password } = this.state;
        if (!loading) {
            try {
                this.updateState({
                    loading: true
                });

                let data = await Login(name, password);

                if (data.code !== void (0)) {
                    this.updateState({
                        errorMessage: data.message,
                        hasError: true,
                        loading: false
                    });
                }
                if (data.access_token !== null && data.access_token !== undefined) {
                    sessionStorage.setItem('tkn', data.access_token);
                    this.updateState({
                        hasError: false,
                        loading: false
                    });
                    this.props.setToken(data.access_token);
                    this.props.history.push("/");
                }
            } catch (e) {
                console.log("Error: " + e);
                this.updateState({
                    hasError: true,
                    loading: false
                });
            }
        }
    }

    render() {
        return (
            <div style={{ width: "100%" }}>
                <div className="page-container" >
                    {
                        this.props.isExpired &&
                        <div style={{ textAlign: "center", border: "1px solid #c3c3c3", padding: "5px 3px", borderRadius: "3px" }}>
                            <i style={{ color: "orange" }} className="fas fa-exclamation-triangle"></i> Your session has expired
                        </div>
                    }
                    <Form onSubmit={() => this.login()} >
                        <h2 className="text-center"> Login </h2>
                        {
                            this.state.hasError &&
                            <div className="error" style={{ border: "1px solid", marginBottom: "15px", padding: "5px 10px", borderRadius: "3px" }}>
                                <i className="fas fa-exclamation-triangle" /> {this.state.errorMessage}                                   
                            </div>
                        }
                        <Input ref={this.username} placeholder="Email" required={true} rules={['isValidEmail']} value={this.state.name} className="form-control" onChange={(e) => this.updateState({ name: e.target.value.trim() })} />
                        <Input ref={this.password}
                            placeholder="Password"
                            required={true}
                            rules={[
                                'minLength',
                                'AplhaNumberic',
                                'containNumber',
                                'containUpperCase',
                                'repeatingChars'
                            ]}
                            type="password"
                            value={this.state.password}
                            className="form-control"
                            onChange={(e) => this.updateState({ password: e.target.value.trim() })} />
                        <Button type="submit" loading={this.state.loading} value="Login" />
                        <Link to="/forgot-password"> Forgot password? </Link>
                    </Form>
                </div>
            </div>	
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/LoginPage.js